/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateZoomPhoneWidgetEventRequest } from '../models';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting404Response } from '../models';
/**
 * ZoomPhoneWidgetEventApi - axios parameter creator
 * @export
 */
export const ZoomPhoneWidgetEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zoom Phone ウィジェットから取得した発信イベント(通話終了など)を保存するAPI。 音声分析の実施状況モニタリングに利用する。 
         * @summary ZoomPhone発信イベント保存API
         * @param {CreateZoomPhoneWidgetEventRequest} createZoomPhoneWidgetEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZoomPhoneWidgetEvent: async (createZoomPhoneWidgetEventRequest: CreateZoomPhoneWidgetEventRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createZoomPhoneWidgetEventRequest' is not null or undefined
            assertParamExists('createZoomPhoneWidgetEvent', 'createZoomPhoneWidgetEventRequest', createZoomPhoneWidgetEventRequest)
            const localVarPath = `/api/user/zoom_phone_widget_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createZoomPhoneWidgetEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoomPhoneWidgetEventApi - functional programming interface
 * @export
 */
export const ZoomPhoneWidgetEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoomPhoneWidgetEventApiAxiosParamCreator(configuration)
    return {
        /**
         * Zoom Phone ウィジェットから取得した発信イベント(通話終了など)を保存するAPI。 音声分析の実施状況モニタリングに利用する。 
         * @summary ZoomPhone発信イベント保存API
         * @param {CreateZoomPhoneWidgetEventRequest} createZoomPhoneWidgetEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createZoomPhoneWidgetEvent(createZoomPhoneWidgetEventRequest: CreateZoomPhoneWidgetEventRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createZoomPhoneWidgetEvent(createZoomPhoneWidgetEventRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoomPhoneWidgetEventApi - factory interface
 * @export
 */
export const ZoomPhoneWidgetEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoomPhoneWidgetEventApiFp(configuration)
    return {
        /**
         * Zoom Phone ウィジェットから取得した発信イベント(通話終了など)を保存するAPI。 音声分析の実施状況モニタリングに利用する。 
         * @summary ZoomPhone発信イベント保存API
         * @param {CreateZoomPhoneWidgetEventRequest} createZoomPhoneWidgetEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZoomPhoneWidgetEvent(createZoomPhoneWidgetEventRequest: CreateZoomPhoneWidgetEventRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createZoomPhoneWidgetEvent(createZoomPhoneWidgetEventRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoomPhoneWidgetEventApi - interface
 * @export
 * @interface ZoomPhoneWidgetEventApi
 */
export interface ZoomPhoneWidgetEventApiInterface {
    /**
     * Zoom Phone ウィジェットから取得した発信イベント(通話終了など)を保存するAPI。 音声分析の実施状況モニタリングに利用する。 
     * @summary ZoomPhone発信イベント保存API
     * @param {CreateZoomPhoneWidgetEventRequest} createZoomPhoneWidgetEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneWidgetEventApiInterface
     */
    createZoomPhoneWidgetEvent(createZoomPhoneWidgetEventRequest: CreateZoomPhoneWidgetEventRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createZoomPhoneWidgetEvent operation in ZoomPhoneWidgetEventApi.
 * @export
 * @interface ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEventRequest
 */
export interface ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEventRequest {
    /**
     * 
     * @type {CreateZoomPhoneWidgetEventRequest}
     * @memberof ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEvent
     */
    readonly createZoomPhoneWidgetEventRequest: CreateZoomPhoneWidgetEventRequest
}

/**
 * ZoomPhoneWidgetEventApi - object-oriented interface
 * @export
 * @class ZoomPhoneWidgetEventApi
 * @extends {BaseAPI}
 */
export class ZoomPhoneWidgetEventApi extends BaseAPI implements ZoomPhoneWidgetEventApiInterface {
    /**
     * Zoom Phone ウィジェットから取得した発信イベント(通話終了など)を保存するAPI。 音声分析の実施状況モニタリングに利用する。 
     * @summary ZoomPhone発信イベント保存API
     * @param {ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneWidgetEventApi
     */
    public createZoomPhoneWidgetEvent(requestParameters: ZoomPhoneWidgetEventApiCreateZoomPhoneWidgetEventRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneWidgetEventApiFp(this.configuration).createZoomPhoneWidgetEvent(requestParameters.createZoomPhoneWidgetEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
